import _ from "lodash";
import { ColumnFlagParser } from '../../utils/helper';

const setProperties = (rowData, col, postfix, isForGrid = false) => {
  const fieldName = "I" + postfix;
  if (rowData.hasOwnProperty(fieldName)) {
    const iValue = rowData[fieldName];
    const cfp = new ColumnFlagParser(iValue);
    if (col.field === "L" + postfix) {
      setColProps(col, cfp.lNoCheck, isForGrid);
    } else if (col.field === "Por" + postfix) {
      setColProps(col, cfp.lNoOrder, isForGrid);
    } else if (col.field === "Sir" + postfix) {
      setColProps(col, cfp.lNoLength, isForGrid);
    } else if (col.field === "Tt" + postfix) {
      setColProps(col, cfp.lNoName, isForGrid);
    }
  }
}

const modifyPropValue = (rowData, control) => {
  const fieldName = "I" + control.field.substring(1);
  let iValue = rowData[fieldName]; //?? detailData.SpFrmSql[fieldName];
  if (!(typeof iValue === 'number')) {
    if (typeof rowData["IFrmSqlUz"] === 'number') {
      // U_FRM_SQL
      iValue = rowData.SpFrmSql?.[fieldName] ?? rowData.FrmSql?.[fieldName];
    } else {
      // SP_FRM_SQL
      iValue = rowData.SpFrmSql?.[fieldName];
    }
  }
  const cfp = new ColumnFlagParser(iValue);
  if (cfp.lVisible !== control.value) {
    cfp.lVisible = control.value;
    rowData[fieldName] = cfp.iColumnFlag;
  }
}

const setColProps = (col, bValue, isForGrid = false) => {
  if (bValue) {
    if (col.required) {
      col.required = false;
    }
    isForGrid ? col.editable = false : col.disabled = true;
  } else {
    isForGrid ? col.editable = true : col.disabled = false;
  }
}

/**
 * Upravi defaultne hodnoty na zaklade obmedzeni v nastaveniach stlpcov
 * @param {*} oldState 
 * @param {*} restrictions 
 * @returns 
 */
const fixDetailData = (oldState, restrictions) => {
  let fixedState = { ...oldState };

  fixedState.detailData.IMriez = restrictions.IMriez;
  const cfpMriez = new ColumnFlagParser(restrictions.IMriez);
  if (cfpMriez.lNoCheck === false) {
    // console.debug(`fixDetailData [fieldIName="LMriez",oldValue="${fixedState.detailData.LMriez}",newValue="${cfpMriez.lVisible}"]`);
    fixedState.detailData.LMriez = cfpMriez.lVisible;
  }

  fixedState.detailData.IDet = restrictions.IDet;
  const cfpDet = new ColumnFlagParser(restrictions.IDet);
  if (cfpDet.lNoCheck === false) {
    // console.debug(`fixDetailData [fieldIName="LDet",oldValue="${fixedState.detailData.LDet}",newValue="${cfpDet.lVisible}"]`);
    fixedState.detailData.LDet = cfpDet.lVisible;
  }

  fixedState.detailData.IHlad = restrictions.IHlad;
  const cfpHlad = new ColumnFlagParser(restrictions.IHlad);
  if (cfpHlad.lNoCheck === false) {
    // console.debug(`fixDetailData [fieldIName="LHlad",oldValue="${fixedState.detailData.LHlad}",newValue="${cfpHlad.lVisible}"]`);
    fixedState.detailData.LHlad = cfpHlad.lVisible;
  }

  fixedState.detailData.IZorad = restrictions.IZorad;
  const cfpZorad = new ColumnFlagParser(restrictions.IZorad);
  if (cfpZorad.lNoCheck === false) {
    // console.debug(`fixDetailData [fieldIName="LZorad",oldValue="${fixedState.detailData.LZorad}",newValue="${cfpZorad.lVisible}"]`);
    fixedState.detailData.LZorad = cfpZorad.lVisible;
  }

  return fixedState;
}

const reducer = async (action, data, state, prevState) => {

  const primaryField = state.primaryField;

  // console.debug(`[action=${action},primaryField="${primaryField}"]`);
  switch (action) {
    case "GET_SCHEMA":
      return state;

    case "GET_LIST":
      return state;

    case "GET":
      {
        const { detailData } = state[primaryField];
        if (detailData.hasOwnProperty("SpFrmSql") && !_.isNil(detailData.SpFrmSql)) {
          const newSchema = prevState.detailSchema.map(x => {
            if (x.field === "LMriez" || x.field === "TtMriez" || x.field === "SirMriez" || x.field === "PorMriez") {
              setProperties(detailData.SpFrmSql, x, "Mriez");
            } else if (x.field === "LDet" || x.field === "TtDet" || x.field === "SirDet" || x.field === "PorDet") {
              setProperties(detailData.SpFrmSql, x, "Det");
            } else if (x.field === "LHlad" || x.field === "TtHlad" || x.field === "SirHlad" || x.field === "PorHlad") {
              setProperties(detailData.SpFrmSql, x, "Hlad");
            } else if (x.field === "LZorad" || x.field === "TtZorad" || x.field === "SirZorad" || x.field === "PorZorad") {
              setProperties(detailData.SpFrmSql, x, "Zorad");
            }
            return x;
          });
          const newGridSchema = prevState.gridSchema.map(x => {
            if (x.field === "LMriez" || x.field === "TtMriez" || x.field === "SirMriez" || x.field === "PorMriez") {
              setProperties(detailData.SpFrmSql, x, "Mriez", true);
            } else if (x.field === "LDet" || x.field === "TtDet" || x.field === "SirDet" || x.field === "PorDet") {
              setProperties(detailData.SpFrmSql, x, "Det", true);
            } else if (x.field === "LHlad" || x.field === "TtHlad" || x.field === "SirHlad" || x.field === "PorHlad") {
              setProperties(detailData.SpFrmSql, x, "Hlad", true);
            } else if (x.field === "LZorad" || x.field === "TtZorad" || x.field === "SirZorad" || x.field === "PorZorad") {
              setProperties(detailData.SpFrmSql, x, "Zorad", true);
            }
            return x;
          });
          return { ...state, detailSchema: newSchema, gridSchema: newGridSchema };
        }
        if (detailData.hasOwnProperty("FrmSql") && !_.isNil(detailData.FrmSql)) {
          const newSchema = prevState.detailSchema.map(x => {
            if (x.field === "LMriez" || x.field === "TtMriez" || x.field === "SirMriez" || x.field === "PorMriez") {
              setProperties(detailData.FrmSql, x, "Mriez");
            } else if (x.field === "LDet" || x.field === "TtDet" || x.field === "SirDet" || x.field === "PorDet") {
              setProperties(detailData.FrmSql, x, "Det");
            } else if (x.field === "LHlad" || x.field === "TtHlad" || x.field === "SirHlad" || x.field === "PorHlad") {
              setProperties(detailData.FrmSql, x, "Hlad");
            } else if (x.field === "LZorad" || x.field === "TtZorad" || x.field === "SirZorad" || x.field === "PorZorad") {
              setProperties(detailData.FrmSql, x, "Zorad");
            }
            return x;
          });
          const newGridSchema = prevState.gridSchema.map(x => {
            if (x.field === "LMriez" || x.field === "TtMriez" || x.field === "SirMriez" || x.field === "PorMriez") {
              setProperties(detailData.FrmSql, x, "Mriez", true);
            } else if (x.field === "LDet" || x.field === "TtDet" || x.field === "SirDet" || x.field === "PorDet") {
              setProperties(detailData.FrmSql, x, "Det", true);
            } else if (x.field === "LHlad" || x.field === "TtHlad" || x.field === "SirHlad" || x.field === "PorHlad") {
              setProperties(detailData.FrmSql, x, "Hlad", true);
            } else if (x.field === "LZorad" || x.field === "TtZorad" || x.field === "SirZorad" || x.field === "PorZorad") {
              setProperties(detailData.FrmSql, x, "Zorad", true);
            }
            return x;
          });
          return { ...state, detailSchema: newSchema, gridSchema: newGridSchema };
        }
      }
      return state;

    case "GET_CREATE":
      const restrictions = state[primaryField]?.detailData?.SpFrmSql ?? state[primaryField]?.detailData?.FrmSql;
      if (!_.isNil(restrictions)) {
        let s = { ...state[primaryField] };
        s = fixDetailData(s, restrictions);
        return { ...state, [primaryField]: s };
      }
      return state;

    case "ENTER_EDIT":
      return state;

    case "EXIT_EDIT":
      return state;

    case "ADD":
      return state;

    case "ITEM_CHANGE":
      console.debug(`[action=${action},field=${data.field},value=${data.value}]`);
      if (data.field === "LMriez" || data.field === "LDet" || data.field === "LHlad" || data.field === "LZorad") {
        modifyPropValue(data.dataItem, data);
      }
      return state;

    case "CHANGE":
      console.debug(`[action=${action},field=${data.field},value=${data.value},oldValue=${data.oldValue}]`);
      if (data.field === "LMriez" || data.field === "LDet" || data.field === "LHlad" || data.field === "LZorad") {
        const { detailData } = state[primaryField];
        modifyPropValue(detailData, data);
      }
      if (data.field === "SpFrmSql" || data.field === "FrmSql") {
        const newSchema = prevState.detailSchema.map(x => {
          if (x.field === "LMriez" || x.field === "TtMriez" || x.field === "SirMriez" || x.field === "PorMriez") {
            setProperties(data.value, x, "Mriez");
          } else if (x.field === "LDet" || x.field === "TtDet" || x.field === "SirDet" || x.field === "PorDet") {
            setProperties(data.value, x, "Det");
          } else if (x.field === "LHlad" || x.field === "TtHlad" || x.field === "SirHlad" || x.field === "PorHlad") {
            setProperties(data.value, x, "Hlad");
          } else if (x.field === "LZorad" || x.field === "TtZorad" || x.field === "SirZorad" || x.field === "PorZorad") {
            setProperties(data.value, x, "Zorad");
          }
          return x;
        });
        let s = { ...state[primaryField] };
        s = fixDetailData(s, data.value);
        return { ...state, detailSchema: newSchema, [primaryField]: s };
      }
      return state;

    case "UPDATE":
      return state;

    case "SELECT":
      return state;

    default:
      return state;
  }
}

export default reducer;
